// extracted by mini-css-extract-plugin
export default {"checkbox":"UserProfileResignFromRoleConfirmContainer_checkbox__CPiXh"};